import Input, { IMask } from './lib/MaskedInput';
export { IMask, Input as MaskedInput };
export default Input;
